/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as CRouteImport } from './routes/c'
import { Route as ClientRouteRouteImport } from './routes/client/route'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ManageRouteRouteImport } from './routes/manage/route'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ClientIndexRouteImport } from './routes/client/index'
import { Route as ClientCalendarRouteImport } from './routes/client/calendar'
import { Route as ClientProfileRouteImport } from './routes/client/profile'
import { Route as ManageIndexRouteImport } from './routes/manage/index'
import { Route as ManageCalendarRouteImport } from './routes/manage/calendar'
import { Route as ManageCompanySettingsRouteImport } from './routes/manage/company-settings'
import { Route as ManageCustomersRouteImport } from './routes/manage/customers'
import { Route as ManageEmployeesRouteImport } from './routes/manage/employees'
import { Route as ManageKnowledgeRouteImport } from './routes/manage/knowledge'
import { Route as ManageRemindersRouteImport } from './routes/manage/reminders'
import { Route as ManageVideoMeetingsRouteImport } from './routes/manage/video-meetings'
import { Route as VPublicTokenRouteImport } from './routes/v/$publicToken'
import { Route as VideoMeetingMeetingIdRouteImport } from './routes/video-meeting/$meetingId'
import { Route as AdminAiGeneralRouteImport } from './routes/admin/ai/general'
import { Route as AdminAiLogsRouteImport } from './routes/admin/ai/logs'
import { Route as AdminConversationOverviewIndexRouteImport } from './routes/admin/conversation-overview/index'
import { Route as AdminConversationOverviewThreadIdRouteImport } from './routes/admin/conversation-overview/$threadId'
import { Route as AdminTenantsIndexRouteImport } from './routes/admin/tenants/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'
import { Route as AdminUsersUserIdRouteImport } from './routes/admin/users/$userId'
import { Route as ClientThreadsIndexRouteImport } from './routes/client/threads/index'
import { Route as ClientThreadsThreadIdRouteImport } from './routes/client/threads/$threadId'
import { Route as ManageCompanyResourcesIndexRouteImport } from './routes/manage/company-resources/index'
import { Route as ManageCompanyServicesIndexRouteImport } from './routes/manage/company-services/index'
import { Route as ManageLeadsIndexRouteImport } from './routes/manage/leads/index'
import { Route as ManageLeadsLeadIdRouteImport } from './routes/manage/leads/$leadId'
import { Route as ManageThreadsIndexRouteImport } from './routes/manage/threads/index'
import { Route as ManageThreadsThreadIdRouteImport } from './routes/manage/threads/$threadId'
import { Route as SsoCasCompleteRouteImport } from './routes/sso/cas/complete'
import { Route as AdminTenantsTenantIdIndexRouteImport } from './routes/admin/tenants/$tenantId/index'
import { Route as AdminTenantsTenantIdEventTriggersRouteImport } from './routes/admin/tenants/$tenantId/event-triggers'
import { Route as AdminTenantsTenantIdLogsRouteImport } from './routes/admin/tenants/$tenantId/logs'
import { Route as AdminTenantsTenantIdModulesRouteImport } from './routes/admin/tenants/$tenantId/modules'
import { Route as ManageCompanyResourcesResourceIdSettingsRouteImport } from './routes/manage/company-resources/$resourceId/settings'
import { Route as ManageCompanyServicesServiceIdManageRouteImport } from './routes/manage/company-services/$serviceId/manage'
import { Route as ManageModulesCvManagerIndexRouteImport } from './modules/cvManager/routes/index'
import { Route as ManageModulesDemoModuleIndexRouteImport } from './modules/demoModule/routes/index'
import { Route as ManageModulesJobModuleIndexRouteImport } from './modules/jobModule/routes/index'
import { Route as ManageModulesKnowledgeBaseIndexRouteImport } from './modules/knowledgeBase/routes/index'
import { Route as ManageModulesPaymentModuleIndexRouteImport } from './modules/paymentModule/routes/index'
import { Route as ManageModulesCvManagerApplicationsApplicationIdSummaryRouteImport } from './modules/cvManager/routes/applications/$applicationId/summary'
import { Route as ManageModulesJobModuleApplicationsApplicationIdSummaryRouteImport } from './modules/jobModule/routes/applications/$applicationId/summary'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const CRoute = CRouteImport.update({
  id: '/c',
  path: '/c',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientRouteRoute = ClientRouteRouteImport.update({
  id: '/client',
  path: '/client',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ManageRouteRoute = ManageRouteRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const ClientIndexRoute = ClientIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ClientRouteRoute,
} as any)
const ClientCalendarRoute = ClientCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => ClientRouteRoute,
} as any)
const ClientProfileRoute = ClientProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ClientRouteRoute,
} as any)
const ManageIndexRoute = ManageIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageCalendarRoute = ManageCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageCompanySettingsRoute = ManageCompanySettingsRouteImport.update({
  id: '/company-settings',
  path: '/company-settings',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageCustomersRoute = ManageCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageEmployeesRoute = ManageEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageKnowledgeRoute = ManageKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageRemindersRoute = ManageRemindersRouteImport.update({
  id: '/reminders',
  path: '/reminders',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageVideoMeetingsRoute = ManageVideoMeetingsRouteImport.update({
  id: '/video-meetings',
  path: '/video-meetings',
  getParentRoute: () => ManageRouteRoute,
} as any)
const VPublicTokenRoute = VPublicTokenRouteImport.update({
  id: '/v/$publicToken',
  path: '/v/$publicToken',
  getParentRoute: () => rootRouteImport,
} as any)
const VideoMeetingMeetingIdRoute = VideoMeetingMeetingIdRouteImport.update({
  id: '/video-meeting/$meetingId',
  path: '/video-meeting/$meetingId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAiGeneralRoute = AdminAiGeneralRouteImport.update({
  id: '/ai/general',
  path: '/ai/general',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAiLogsRoute = AdminAiLogsRouteImport.update({
  id: '/ai/logs',
  path: '/ai/logs',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminConversationOverviewIndexRoute =
  AdminConversationOverviewIndexRouteImport.update({
    id: '/conversation-overview/',
    path: '/conversation-overview/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminConversationOverviewThreadIdRoute =
  AdminConversationOverviewThreadIdRouteImport.update({
    id: '/conversation-overview/$threadId',
    path: '/conversation-overview/$threadId',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTenantsIndexRoute = AdminTenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminUsersUserIdRoute = AdminUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AdminRouteRoute,
} as any)
const ClientThreadsIndexRoute = ClientThreadsIndexRouteImport.update({
  id: '/threads/',
  path: '/threads/',
  getParentRoute: () => ClientRouteRoute,
} as any)
const ClientThreadsThreadIdRoute = ClientThreadsThreadIdRouteImport.update({
  id: '/threads/$threadId',
  path: '/threads/$threadId',
  getParentRoute: () => ClientRouteRoute,
} as any)
const ManageCompanyResourcesIndexRoute =
  ManageCompanyResourcesIndexRouteImport.update({
    id: '/company-resources/',
    path: '/company-resources/',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageCompanyServicesIndexRoute =
  ManageCompanyServicesIndexRouteImport.update({
    id: '/company-services/',
    path: '/company-services/',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageLeadsIndexRoute = ManageLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageLeadsLeadIdRoute = ManageLeadsLeadIdRouteImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageThreadsIndexRoute = ManageThreadsIndexRouteImport.update({
  id: '/threads/',
  path: '/threads/',
  getParentRoute: () => ManageRouteRoute,
} as any)
const ManageThreadsThreadIdRoute = ManageThreadsThreadIdRouteImport.update({
  id: '/threads/$threadId',
  path: '/threads/$threadId',
  getParentRoute: () => ManageRouteRoute,
} as any)
const SsoCasCompleteRoute = SsoCasCompleteRouteImport.update({
  id: '/sso/cas/complete',
  path: '/sso/cas/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTenantsTenantIdIndexRoute =
  AdminTenantsTenantIdIndexRouteImport.update({
    id: '/tenants/$tenantId/',
    path: '/tenants/$tenantId/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTenantsTenantIdEventTriggersRoute =
  AdminTenantsTenantIdEventTriggersRouteImport.update({
    id: '/tenants/$tenantId/event-triggers',
    path: '/tenants/$tenantId/event-triggers',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTenantsTenantIdLogsRoute =
  AdminTenantsTenantIdLogsRouteImport.update({
    id: '/tenants/$tenantId/logs',
    path: '/tenants/$tenantId/logs',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminTenantsTenantIdModulesRoute =
  AdminTenantsTenantIdModulesRouteImport.update({
    id: '/tenants/$tenantId/modules',
    path: '/tenants/$tenantId/modules',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const ManageCompanyResourcesResourceIdSettingsRoute =
  ManageCompanyResourcesResourceIdSettingsRouteImport.update({
    id: '/company-resources/$resourceId/settings',
    path: '/company-resources/$resourceId/settings',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageCompanyServicesServiceIdManageRoute =
  ManageCompanyServicesServiceIdManageRouteImport.update({
    id: '/company-services/$serviceId/manage',
    path: '/company-services/$serviceId/manage',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageModulesCvManagerIndexRoute =
  ManageModulesCvManagerIndexRouteImport.update({
    id: '/modules/cvManager/',
    path: '/modules/cvManager/',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageModulesDemoModuleIndexRoute =
  ManageModulesDemoModuleIndexRouteImport.update({
    id: '/modules/demoModule/',
    path: '/modules/demoModule/',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageModulesJobModuleIndexRoute =
  ManageModulesJobModuleIndexRouteImport.update({
    id: '/modules/jobModule/',
    path: '/modules/jobModule/',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageModulesKnowledgeBaseIndexRoute =
  ManageModulesKnowledgeBaseIndexRouteImport.update({
    id: '/modules/knowledgeBase/',
    path: '/modules/knowledgeBase/',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageModulesPaymentModuleIndexRoute =
  ManageModulesPaymentModuleIndexRouteImport.update({
    id: '/modules/paymentModule/',
    path: '/modules/paymentModule/',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageModulesCvManagerApplicationsApplicationIdSummaryRoute =
  ManageModulesCvManagerApplicationsApplicationIdSummaryRouteImport.update({
    id: '/modules/cvManager/applications/$applicationId/summary',
    path: '/modules/cvManager/applications/$applicationId/summary',
    getParentRoute: () => ManageRouteRoute,
  } as any)
const ManageModulesJobModuleApplicationsApplicationIdSummaryRoute =
  ManageModulesJobModuleApplicationsApplicationIdSummaryRouteImport.update({
    id: '/modules/jobModule/applications/$applicationId/summary',
    path: '/modules/jobModule/applications/$applicationId/summary',
    getParentRoute: () => ManageRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/client': typeof ClientRouteRouteWithChildren
  '/manage': typeof ManageRouteRouteWithChildren
  '/c': typeof CRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/client/calendar': typeof ClientCalendarRoute
  '/client/profile': typeof ClientProfileRoute
  '/manage/calendar': typeof ManageCalendarRoute
  '/manage/company-settings': typeof ManageCompanySettingsRoute
  '/manage/customers': typeof ManageCustomersRoute
  '/manage/employees': typeof ManageEmployeesRoute
  '/manage/knowledge': typeof ManageKnowledgeRoute
  '/manage/reminders': typeof ManageRemindersRoute
  '/manage/video-meetings': typeof ManageVideoMeetingsRoute
  '/v/$publicToken': typeof VPublicTokenRoute
  '/video-meeting/$meetingId': typeof VideoMeetingMeetingIdRoute
  '/admin/': typeof AdminIndexRoute
  '/client/': typeof ClientIndexRoute
  '/manage/': typeof ManageIndexRoute
  '/admin/ai/general': typeof AdminAiGeneralRoute
  '/admin/ai/logs': typeof AdminAiLogsRoute
  '/admin/conversation-overview/$threadId': typeof AdminConversationOverviewThreadIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/client/threads/$threadId': typeof ClientThreadsThreadIdRoute
  '/manage/leads/$leadId': typeof ManageLeadsLeadIdRoute
  '/manage/threads/$threadId': typeof ManageThreadsThreadIdRoute
  '/sso/cas/complete': typeof SsoCasCompleteRoute
  '/admin/conversation-overview/': typeof AdminConversationOverviewIndexRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/client/threads/': typeof ClientThreadsIndexRoute
  '/manage/company-resources/': typeof ManageCompanyResourcesIndexRoute
  '/manage/company-services/': typeof ManageCompanyServicesIndexRoute
  '/manage/leads/': typeof ManageLeadsIndexRoute
  '/manage/threads/': typeof ManageThreadsIndexRoute
  '/admin/tenants/$tenantId/event-triggers': typeof AdminTenantsTenantIdEventTriggersRoute
  '/admin/tenants/$tenantId/logs': typeof AdminTenantsTenantIdLogsRoute
  '/admin/tenants/$tenantId/modules': typeof AdminTenantsTenantIdModulesRoute
  '/manage/company-resources/$resourceId/settings': typeof ManageCompanyResourcesResourceIdSettingsRoute
  '/manage/company-services/$serviceId/manage': typeof ManageCompanyServicesServiceIdManageRoute
  '/admin/tenants/$tenantId/': typeof AdminTenantsTenantIdIndexRoute
  '/manage/modules/cvManager/': typeof ManageModulesCvManagerIndexRoute
  '/manage/modules/demoModule/': typeof ManageModulesDemoModuleIndexRoute
  '/manage/modules/jobModule/': typeof ManageModulesJobModuleIndexRoute
  '/manage/modules/knowledgeBase/': typeof ManageModulesKnowledgeBaseIndexRoute
  '/manage/modules/paymentModule/': typeof ManageModulesPaymentModuleIndexRoute
  '/manage/modules/cvManager/applications/$applicationId/summary': typeof ManageModulesCvManagerApplicationsApplicationIdSummaryRoute
  '/manage/modules/jobModule/applications/$applicationId/summary': typeof ManageModulesJobModuleApplicationsApplicationIdSummaryRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/c': typeof CRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/client/calendar': typeof ClientCalendarRoute
  '/client/profile': typeof ClientProfileRoute
  '/manage/calendar': typeof ManageCalendarRoute
  '/manage/company-settings': typeof ManageCompanySettingsRoute
  '/manage/customers': typeof ManageCustomersRoute
  '/manage/employees': typeof ManageEmployeesRoute
  '/manage/knowledge': typeof ManageKnowledgeRoute
  '/manage/reminders': typeof ManageRemindersRoute
  '/manage/video-meetings': typeof ManageVideoMeetingsRoute
  '/v/$publicToken': typeof VPublicTokenRoute
  '/video-meeting/$meetingId': typeof VideoMeetingMeetingIdRoute
  '/admin': typeof AdminIndexRoute
  '/client': typeof ClientIndexRoute
  '/manage': typeof ManageIndexRoute
  '/admin/ai/general': typeof AdminAiGeneralRoute
  '/admin/ai/logs': typeof AdminAiLogsRoute
  '/admin/conversation-overview/$threadId': typeof AdminConversationOverviewThreadIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/client/threads/$threadId': typeof ClientThreadsThreadIdRoute
  '/manage/leads/$leadId': typeof ManageLeadsLeadIdRoute
  '/manage/threads/$threadId': typeof ManageThreadsThreadIdRoute
  '/sso/cas/complete': typeof SsoCasCompleteRoute
  '/admin/conversation-overview': typeof AdminConversationOverviewIndexRoute
  '/admin/tenants': typeof AdminTenantsIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
  '/client/threads': typeof ClientThreadsIndexRoute
  '/manage/company-resources': typeof ManageCompanyResourcesIndexRoute
  '/manage/company-services': typeof ManageCompanyServicesIndexRoute
  '/manage/leads': typeof ManageLeadsIndexRoute
  '/manage/threads': typeof ManageThreadsIndexRoute
  '/admin/tenants/$tenantId/event-triggers': typeof AdminTenantsTenantIdEventTriggersRoute
  '/admin/tenants/$tenantId/logs': typeof AdminTenantsTenantIdLogsRoute
  '/admin/tenants/$tenantId/modules': typeof AdminTenantsTenantIdModulesRoute
  '/manage/company-resources/$resourceId/settings': typeof ManageCompanyResourcesResourceIdSettingsRoute
  '/manage/company-services/$serviceId/manage': typeof ManageCompanyServicesServiceIdManageRoute
  '/admin/tenants/$tenantId': typeof AdminTenantsTenantIdIndexRoute
  '/manage/modules/cvManager': typeof ManageModulesCvManagerIndexRoute
  '/manage/modules/demoModule': typeof ManageModulesDemoModuleIndexRoute
  '/manage/modules/jobModule': typeof ManageModulesJobModuleIndexRoute
  '/manage/modules/knowledgeBase': typeof ManageModulesKnowledgeBaseIndexRoute
  '/manage/modules/paymentModule': typeof ManageModulesPaymentModuleIndexRoute
  '/manage/modules/cvManager/applications/$applicationId/summary': typeof ManageModulesCvManagerApplicationsApplicationIdSummaryRoute
  '/manage/modules/jobModule/applications/$applicationId/summary': typeof ManageModulesJobModuleApplicationsApplicationIdSummaryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/client': typeof ClientRouteRouteWithChildren
  '/manage': typeof ManageRouteRouteWithChildren
  '/c': typeof CRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/verify-email': typeof VerifyEmailRoute
  '/client/calendar': typeof ClientCalendarRoute
  '/client/profile': typeof ClientProfileRoute
  '/manage/calendar': typeof ManageCalendarRoute
  '/manage/company-settings': typeof ManageCompanySettingsRoute
  '/manage/customers': typeof ManageCustomersRoute
  '/manage/employees': typeof ManageEmployeesRoute
  '/manage/knowledge': typeof ManageKnowledgeRoute
  '/manage/reminders': typeof ManageRemindersRoute
  '/manage/video-meetings': typeof ManageVideoMeetingsRoute
  '/v/$publicToken': typeof VPublicTokenRoute
  '/video-meeting/$meetingId': typeof VideoMeetingMeetingIdRoute
  '/admin/': typeof AdminIndexRoute
  '/client/': typeof ClientIndexRoute
  '/manage/': typeof ManageIndexRoute
  '/admin/ai/general': typeof AdminAiGeneralRoute
  '/admin/ai/logs': typeof AdminAiLogsRoute
  '/admin/conversation-overview/$threadId': typeof AdminConversationOverviewThreadIdRoute
  '/admin/users/$userId': typeof AdminUsersUserIdRoute
  '/client/threads/$threadId': typeof ClientThreadsThreadIdRoute
  '/manage/leads/$leadId': typeof ManageLeadsLeadIdRoute
  '/manage/threads/$threadId': typeof ManageThreadsThreadIdRoute
  '/sso/cas/complete': typeof SsoCasCompleteRoute
  '/admin/conversation-overview/': typeof AdminConversationOverviewIndexRoute
  '/admin/tenants/': typeof AdminTenantsIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
  '/client/threads/': typeof ClientThreadsIndexRoute
  '/manage/company-resources/': typeof ManageCompanyResourcesIndexRoute
  '/manage/company-services/': typeof ManageCompanyServicesIndexRoute
  '/manage/leads/': typeof ManageLeadsIndexRoute
  '/manage/threads/': typeof ManageThreadsIndexRoute
  '/admin/tenants/$tenantId/event-triggers': typeof AdminTenantsTenantIdEventTriggersRoute
  '/admin/tenants/$tenantId/logs': typeof AdminTenantsTenantIdLogsRoute
  '/admin/tenants/$tenantId/modules': typeof AdminTenantsTenantIdModulesRoute
  '/manage/company-resources/$resourceId/settings': typeof ManageCompanyResourcesResourceIdSettingsRoute
  '/manage/company-services/$serviceId/manage': typeof ManageCompanyServicesServiceIdManageRoute
  '/admin/tenants/$tenantId/': typeof AdminTenantsTenantIdIndexRoute
  '/manage/modules/cvManager/': typeof ManageModulesCvManagerIndexRoute
  '/manage/modules/demoModule/': typeof ManageModulesDemoModuleIndexRoute
  '/manage/modules/jobModule/': typeof ManageModulesJobModuleIndexRoute
  '/manage/modules/knowledgeBase/': typeof ManageModulesKnowledgeBaseIndexRoute
  '/manage/modules/paymentModule/': typeof ManageModulesPaymentModuleIndexRoute
  '/manage/modules/cvManager/applications/$applicationId/summary': typeof ManageModulesCvManagerApplicationsApplicationIdSummaryRoute
  '/manage/modules/jobModule/applications/$applicationId/summary': typeof ManageModulesJobModuleApplicationsApplicationIdSummaryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/client'
    | '/manage'
    | '/c'
    | '/forgot-password'
    | '/login'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/client/calendar'
    | '/client/profile'
    | '/manage/calendar'
    | '/manage/company-settings'
    | '/manage/customers'
    | '/manage/employees'
    | '/manage/knowledge'
    | '/manage/reminders'
    | '/manage/video-meetings'
    | '/v/$publicToken'
    | '/video-meeting/$meetingId'
    | '/admin/'
    | '/client/'
    | '/manage/'
    | '/admin/ai/general'
    | '/admin/ai/logs'
    | '/admin/conversation-overview/$threadId'
    | '/admin/users/$userId'
    | '/client/threads/$threadId'
    | '/manage/leads/$leadId'
    | '/manage/threads/$threadId'
    | '/sso/cas/complete'
    | '/admin/conversation-overview/'
    | '/admin/tenants/'
    | '/admin/users/'
    | '/client/threads/'
    | '/manage/company-resources/'
    | '/manage/company-services/'
    | '/manage/leads/'
    | '/manage/threads/'
    | '/admin/tenants/$tenantId/event-triggers'
    | '/admin/tenants/$tenantId/logs'
    | '/admin/tenants/$tenantId/modules'
    | '/manage/company-resources/$resourceId/settings'
    | '/manage/company-services/$serviceId/manage'
    | '/admin/tenants/$tenantId/'
    | '/manage/modules/cvManager/'
    | '/manage/modules/demoModule/'
    | '/manage/modules/jobModule/'
    | '/manage/modules/knowledgeBase/'
    | '/manage/modules/paymentModule/'
    | '/manage/modules/cvManager/applications/$applicationId/summary'
    | '/manage/modules/jobModule/applications/$applicationId/summary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/c'
    | '/forgot-password'
    | '/login'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/client/calendar'
    | '/client/profile'
    | '/manage/calendar'
    | '/manage/company-settings'
    | '/manage/customers'
    | '/manage/employees'
    | '/manage/knowledge'
    | '/manage/reminders'
    | '/manage/video-meetings'
    | '/v/$publicToken'
    | '/video-meeting/$meetingId'
    | '/admin'
    | '/client'
    | '/manage'
    | '/admin/ai/general'
    | '/admin/ai/logs'
    | '/admin/conversation-overview/$threadId'
    | '/admin/users/$userId'
    | '/client/threads/$threadId'
    | '/manage/leads/$leadId'
    | '/manage/threads/$threadId'
    | '/sso/cas/complete'
    | '/admin/conversation-overview'
    | '/admin/tenants'
    | '/admin/users'
    | '/client/threads'
    | '/manage/company-resources'
    | '/manage/company-services'
    | '/manage/leads'
    | '/manage/threads'
    | '/admin/tenants/$tenantId/event-triggers'
    | '/admin/tenants/$tenantId/logs'
    | '/admin/tenants/$tenantId/modules'
    | '/manage/company-resources/$resourceId/settings'
    | '/manage/company-services/$serviceId/manage'
    | '/admin/tenants/$tenantId'
    | '/manage/modules/cvManager'
    | '/manage/modules/demoModule'
    | '/manage/modules/jobModule'
    | '/manage/modules/knowledgeBase'
    | '/manage/modules/paymentModule'
    | '/manage/modules/cvManager/applications/$applicationId/summary'
    | '/manage/modules/jobModule/applications/$applicationId/summary'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/client'
    | '/manage'
    | '/c'
    | '/forgot-password'
    | '/login'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/client/calendar'
    | '/client/profile'
    | '/manage/calendar'
    | '/manage/company-settings'
    | '/manage/customers'
    | '/manage/employees'
    | '/manage/knowledge'
    | '/manage/reminders'
    | '/manage/video-meetings'
    | '/v/$publicToken'
    | '/video-meeting/$meetingId'
    | '/admin/'
    | '/client/'
    | '/manage/'
    | '/admin/ai/general'
    | '/admin/ai/logs'
    | '/admin/conversation-overview/$threadId'
    | '/admin/users/$userId'
    | '/client/threads/$threadId'
    | '/manage/leads/$leadId'
    | '/manage/threads/$threadId'
    | '/sso/cas/complete'
    | '/admin/conversation-overview/'
    | '/admin/tenants/'
    | '/admin/users/'
    | '/client/threads/'
    | '/manage/company-resources/'
    | '/manage/company-services/'
    | '/manage/leads/'
    | '/manage/threads/'
    | '/admin/tenants/$tenantId/event-triggers'
    | '/admin/tenants/$tenantId/logs'
    | '/admin/tenants/$tenantId/modules'
    | '/manage/company-resources/$resourceId/settings'
    | '/manage/company-services/$serviceId/manage'
    | '/admin/tenants/$tenantId/'
    | '/manage/modules/cvManager/'
    | '/manage/modules/demoModule/'
    | '/manage/modules/jobModule/'
    | '/manage/modules/knowledgeBase/'
    | '/manage/modules/paymentModule/'
    | '/manage/modules/cvManager/applications/$applicationId/summary'
    | '/manage/modules/jobModule/applications/$applicationId/summary'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  ClientRouteRoute: typeof ClientRouteRouteWithChildren
  ManageRouteRoute: typeof ManageRouteRouteWithChildren
  CRoute: typeof CRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ProfileRoute: typeof ProfileRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  VPublicTokenRoute: typeof VPublicTokenRoute
  VideoMeetingMeetingIdRoute: typeof VideoMeetingMeetingIdRoute
  SsoCasCompleteRoute: typeof SsoCasCompleteRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c': {
      id: '/c'
      path: '/c'
      fullPath: '/c'
      preLoaderRoute: typeof CRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/client': {
      id: '/client'
      path: '/client'
      fullPath: '/client'
      preLoaderRoute: typeof ClientRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manage': {
      id: '/manage'
      path: '/manage'
      fullPath: '/manage'
      preLoaderRoute: typeof ManageRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/client/': {
      id: '/client/'
      path: '/'
      fullPath: '/client/'
      preLoaderRoute: typeof ClientIndexRouteImport
      parentRoute: typeof ClientRouteRoute
    }
    '/client/calendar': {
      id: '/client/calendar'
      path: '/calendar'
      fullPath: '/client/calendar'
      preLoaderRoute: typeof ClientCalendarRouteImport
      parentRoute: typeof ClientRouteRoute
    }
    '/client/profile': {
      id: '/client/profile'
      path: '/profile'
      fullPath: '/client/profile'
      preLoaderRoute: typeof ClientProfileRouteImport
      parentRoute: typeof ClientRouteRoute
    }
    '/manage/': {
      id: '/manage/'
      path: '/'
      fullPath: '/manage/'
      preLoaderRoute: typeof ManageIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/calendar': {
      id: '/manage/calendar'
      path: '/calendar'
      fullPath: '/manage/calendar'
      preLoaderRoute: typeof ManageCalendarRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/company-settings': {
      id: '/manage/company-settings'
      path: '/company-settings'
      fullPath: '/manage/company-settings'
      preLoaderRoute: typeof ManageCompanySettingsRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/customers': {
      id: '/manage/customers'
      path: '/customers'
      fullPath: '/manage/customers'
      preLoaderRoute: typeof ManageCustomersRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/employees': {
      id: '/manage/employees'
      path: '/employees'
      fullPath: '/manage/employees'
      preLoaderRoute: typeof ManageEmployeesRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/knowledge': {
      id: '/manage/knowledge'
      path: '/knowledge'
      fullPath: '/manage/knowledge'
      preLoaderRoute: typeof ManageKnowledgeRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/reminders': {
      id: '/manage/reminders'
      path: '/reminders'
      fullPath: '/manage/reminders'
      preLoaderRoute: typeof ManageRemindersRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/video-meetings': {
      id: '/manage/video-meetings'
      path: '/video-meetings'
      fullPath: '/manage/video-meetings'
      preLoaderRoute: typeof ManageVideoMeetingsRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/v/$publicToken': {
      id: '/v/$publicToken'
      path: '/v/$publicToken'
      fullPath: '/v/$publicToken'
      preLoaderRoute: typeof VPublicTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/video-meeting/$meetingId': {
      id: '/video-meeting/$meetingId'
      path: '/video-meeting/$meetingId'
      fullPath: '/video-meeting/$meetingId'
      preLoaderRoute: typeof VideoMeetingMeetingIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ai/general': {
      id: '/admin/ai/general'
      path: '/ai/general'
      fullPath: '/admin/ai/general'
      preLoaderRoute: typeof AdminAiGeneralRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/ai/logs': {
      id: '/admin/ai/logs'
      path: '/ai/logs'
      fullPath: '/admin/ai/logs'
      preLoaderRoute: typeof AdminAiLogsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/conversation-overview/': {
      id: '/admin/conversation-overview/'
      path: '/conversation-overview'
      fullPath: '/admin/conversation-overview/'
      preLoaderRoute: typeof AdminConversationOverviewIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/conversation-overview/$threadId': {
      id: '/admin/conversation-overview/$threadId'
      path: '/conversation-overview/$threadId'
      fullPath: '/admin/conversation-overview/$threadId'
      preLoaderRoute: typeof AdminConversationOverviewThreadIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tenants/': {
      id: '/admin/tenants/'
      path: '/tenants'
      fullPath: '/admin/tenants/'
      preLoaderRoute: typeof AdminTenantsIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users/$userId': {
      id: '/admin/users/$userId'
      path: '/users/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AdminUsersUserIdRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/client/threads/': {
      id: '/client/threads/'
      path: '/threads'
      fullPath: '/client/threads/'
      preLoaderRoute: typeof ClientThreadsIndexRouteImport
      parentRoute: typeof ClientRouteRoute
    }
    '/client/threads/$threadId': {
      id: '/client/threads/$threadId'
      path: '/threads/$threadId'
      fullPath: '/client/threads/$threadId'
      preLoaderRoute: typeof ClientThreadsThreadIdRouteImport
      parentRoute: typeof ClientRouteRoute
    }
    '/manage/company-resources/': {
      id: '/manage/company-resources/'
      path: '/company-resources'
      fullPath: '/manage/company-resources/'
      preLoaderRoute: typeof ManageCompanyResourcesIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/company-services/': {
      id: '/manage/company-services/'
      path: '/company-services'
      fullPath: '/manage/company-services/'
      preLoaderRoute: typeof ManageCompanyServicesIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/leads/': {
      id: '/manage/leads/'
      path: '/leads'
      fullPath: '/manage/leads/'
      preLoaderRoute: typeof ManageLeadsIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/leads/$leadId': {
      id: '/manage/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/manage/leads/$leadId'
      preLoaderRoute: typeof ManageLeadsLeadIdRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/threads/': {
      id: '/manage/threads/'
      path: '/threads'
      fullPath: '/manage/threads/'
      preLoaderRoute: typeof ManageThreadsIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/threads/$threadId': {
      id: '/manage/threads/$threadId'
      path: '/threads/$threadId'
      fullPath: '/manage/threads/$threadId'
      preLoaderRoute: typeof ManageThreadsThreadIdRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/sso/cas/complete': {
      id: '/sso/cas/complete'
      path: '/sso/cas/complete'
      fullPath: '/sso/cas/complete'
      preLoaderRoute: typeof SsoCasCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tenants/$tenantId/': {
      id: '/admin/tenants/$tenantId/'
      path: '/tenants/$tenantId'
      fullPath: '/admin/tenants/$tenantId/'
      preLoaderRoute: typeof AdminTenantsTenantIdIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tenants/$tenantId/event-triggers': {
      id: '/admin/tenants/$tenantId/event-triggers'
      path: '/tenants/$tenantId/event-triggers'
      fullPath: '/admin/tenants/$tenantId/event-triggers'
      preLoaderRoute: typeof AdminTenantsTenantIdEventTriggersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tenants/$tenantId/logs': {
      id: '/admin/tenants/$tenantId/logs'
      path: '/tenants/$tenantId/logs'
      fullPath: '/admin/tenants/$tenantId/logs'
      preLoaderRoute: typeof AdminTenantsTenantIdLogsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/tenants/$tenantId/modules': {
      id: '/admin/tenants/$tenantId/modules'
      path: '/tenants/$tenantId/modules'
      fullPath: '/admin/tenants/$tenantId/modules'
      preLoaderRoute: typeof AdminTenantsTenantIdModulesRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/manage/company-resources/$resourceId/settings': {
      id: '/manage/company-resources/$resourceId/settings'
      path: '/company-resources/$resourceId/settings'
      fullPath: '/manage/company-resources/$resourceId/settings'
      preLoaderRoute: typeof ManageCompanyResourcesResourceIdSettingsRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/company-services/$serviceId/manage': {
      id: '/manage/company-services/$serviceId/manage'
      path: '/company-services/$serviceId/manage'
      fullPath: '/manage/company-services/$serviceId/manage'
      preLoaderRoute: typeof ManageCompanyServicesServiceIdManageRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/modules/cvManager/': {
      id: '/manage/modules/cvManager/'
      path: '/modules/cvManager'
      fullPath: '/manage/modules/cvManager/'
      preLoaderRoute: typeof ManageModulesCvManagerIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/modules/demoModule/': {
      id: '/manage/modules/demoModule/'
      path: '/modules/demoModule'
      fullPath: '/manage/modules/demoModule/'
      preLoaderRoute: typeof ManageModulesDemoModuleIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/modules/jobModule/': {
      id: '/manage/modules/jobModule/'
      path: '/modules/jobModule'
      fullPath: '/manage/modules/jobModule/'
      preLoaderRoute: typeof ManageModulesJobModuleIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/modules/knowledgeBase/': {
      id: '/manage/modules/knowledgeBase/'
      path: '/modules/knowledgeBase'
      fullPath: '/manage/modules/knowledgeBase/'
      preLoaderRoute: typeof ManageModulesKnowledgeBaseIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/modules/paymentModule/': {
      id: '/manage/modules/paymentModule/'
      path: '/modules/paymentModule'
      fullPath: '/manage/modules/paymentModule/'
      preLoaderRoute: typeof ManageModulesPaymentModuleIndexRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/modules/cvManager/applications/$applicationId/summary': {
      id: '/manage/modules/cvManager/applications/$applicationId/summary'
      path: '/modules/cvManager/applications/$applicationId/summary'
      fullPath: '/manage/modules/cvManager/applications/$applicationId/summary'
      preLoaderRoute: typeof ManageModulesCvManagerApplicationsApplicationIdSummaryRouteImport
      parentRoute: typeof ManageRouteRoute
    }
    '/manage/modules/jobModule/applications/$applicationId/summary': {
      id: '/manage/modules/jobModule/applications/$applicationId/summary'
      path: '/modules/jobModule/applications/$applicationId/summary'
      fullPath: '/manage/modules/jobModule/applications/$applicationId/summary'
      preLoaderRoute: typeof ManageModulesJobModuleApplicationsApplicationIdSummaryRouteImport
      parentRoute: typeof ManageRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminAiGeneralRoute: typeof AdminAiGeneralRoute
  AdminAiLogsRoute: typeof AdminAiLogsRoute
  AdminConversationOverviewThreadIdRoute: typeof AdminConversationOverviewThreadIdRoute
  AdminUsersUserIdRoute: typeof AdminUsersUserIdRoute
  AdminConversationOverviewIndexRoute: typeof AdminConversationOverviewIndexRoute
  AdminTenantsIndexRoute: typeof AdminTenantsIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AdminTenantsTenantIdEventTriggersRoute: typeof AdminTenantsTenantIdEventTriggersRoute
  AdminTenantsTenantIdLogsRoute: typeof AdminTenantsTenantIdLogsRoute
  AdminTenantsTenantIdModulesRoute: typeof AdminTenantsTenantIdModulesRoute
  AdminTenantsTenantIdIndexRoute: typeof AdminTenantsTenantIdIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminAiGeneralRoute: AdminAiGeneralRoute,
  AdminAiLogsRoute: AdminAiLogsRoute,
  AdminConversationOverviewThreadIdRoute:
    AdminConversationOverviewThreadIdRoute,
  AdminUsersUserIdRoute: AdminUsersUserIdRoute,
  AdminConversationOverviewIndexRoute: AdminConversationOverviewIndexRoute,
  AdminTenantsIndexRoute: AdminTenantsIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AdminTenantsTenantIdEventTriggersRoute:
    AdminTenantsTenantIdEventTriggersRoute,
  AdminTenantsTenantIdLogsRoute: AdminTenantsTenantIdLogsRoute,
  AdminTenantsTenantIdModulesRoute: AdminTenantsTenantIdModulesRoute,
  AdminTenantsTenantIdIndexRoute: AdminTenantsTenantIdIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface ClientRouteRouteChildren {
  ClientCalendarRoute: typeof ClientCalendarRoute
  ClientProfileRoute: typeof ClientProfileRoute
  ClientIndexRoute: typeof ClientIndexRoute
  ClientThreadsThreadIdRoute: typeof ClientThreadsThreadIdRoute
  ClientThreadsIndexRoute: typeof ClientThreadsIndexRoute
}

const ClientRouteRouteChildren: ClientRouteRouteChildren = {
  ClientCalendarRoute: ClientCalendarRoute,
  ClientProfileRoute: ClientProfileRoute,
  ClientIndexRoute: ClientIndexRoute,
  ClientThreadsThreadIdRoute: ClientThreadsThreadIdRoute,
  ClientThreadsIndexRoute: ClientThreadsIndexRoute,
}

const ClientRouteRouteWithChildren = ClientRouteRoute._addFileChildren(
  ClientRouteRouteChildren,
)

interface ManageRouteRouteChildren {
  ManageCalendarRoute: typeof ManageCalendarRoute
  ManageCompanySettingsRoute: typeof ManageCompanySettingsRoute
  ManageCustomersRoute: typeof ManageCustomersRoute
  ManageEmployeesRoute: typeof ManageEmployeesRoute
  ManageKnowledgeRoute: typeof ManageKnowledgeRoute
  ManageRemindersRoute: typeof ManageRemindersRoute
  ManageVideoMeetingsRoute: typeof ManageVideoMeetingsRoute
  ManageIndexRoute: typeof ManageIndexRoute
  ManageLeadsLeadIdRoute: typeof ManageLeadsLeadIdRoute
  ManageThreadsThreadIdRoute: typeof ManageThreadsThreadIdRoute
  ManageCompanyResourcesIndexRoute: typeof ManageCompanyResourcesIndexRoute
  ManageCompanyServicesIndexRoute: typeof ManageCompanyServicesIndexRoute
  ManageLeadsIndexRoute: typeof ManageLeadsIndexRoute
  ManageThreadsIndexRoute: typeof ManageThreadsIndexRoute
  ManageCompanyResourcesResourceIdSettingsRoute: typeof ManageCompanyResourcesResourceIdSettingsRoute
  ManageCompanyServicesServiceIdManageRoute: typeof ManageCompanyServicesServiceIdManageRoute
  ManageModulesCvManagerIndexRoute: typeof ManageModulesCvManagerIndexRoute
  ManageModulesDemoModuleIndexRoute: typeof ManageModulesDemoModuleIndexRoute
  ManageModulesJobModuleIndexRoute: typeof ManageModulesJobModuleIndexRoute
  ManageModulesKnowledgeBaseIndexRoute: typeof ManageModulesKnowledgeBaseIndexRoute
  ManageModulesPaymentModuleIndexRoute: typeof ManageModulesPaymentModuleIndexRoute
  ManageModulesCvManagerApplicationsApplicationIdSummaryRoute: typeof ManageModulesCvManagerApplicationsApplicationIdSummaryRoute
  ManageModulesJobModuleApplicationsApplicationIdSummaryRoute: typeof ManageModulesJobModuleApplicationsApplicationIdSummaryRoute
}

const ManageRouteRouteChildren: ManageRouteRouteChildren = {
  ManageCalendarRoute: ManageCalendarRoute,
  ManageCompanySettingsRoute: ManageCompanySettingsRoute,
  ManageCustomersRoute: ManageCustomersRoute,
  ManageEmployeesRoute: ManageEmployeesRoute,
  ManageKnowledgeRoute: ManageKnowledgeRoute,
  ManageRemindersRoute: ManageRemindersRoute,
  ManageVideoMeetingsRoute: ManageVideoMeetingsRoute,
  ManageIndexRoute: ManageIndexRoute,
  ManageLeadsLeadIdRoute: ManageLeadsLeadIdRoute,
  ManageThreadsThreadIdRoute: ManageThreadsThreadIdRoute,
  ManageCompanyResourcesIndexRoute: ManageCompanyResourcesIndexRoute,
  ManageCompanyServicesIndexRoute: ManageCompanyServicesIndexRoute,
  ManageLeadsIndexRoute: ManageLeadsIndexRoute,
  ManageThreadsIndexRoute: ManageThreadsIndexRoute,
  ManageCompanyResourcesResourceIdSettingsRoute:
    ManageCompanyResourcesResourceIdSettingsRoute,
  ManageCompanyServicesServiceIdManageRoute:
    ManageCompanyServicesServiceIdManageRoute,
  ManageModulesCvManagerIndexRoute: ManageModulesCvManagerIndexRoute,
  ManageModulesDemoModuleIndexRoute: ManageModulesDemoModuleIndexRoute,
  ManageModulesJobModuleIndexRoute: ManageModulesJobModuleIndexRoute,
  ManageModulesKnowledgeBaseIndexRoute: ManageModulesKnowledgeBaseIndexRoute,
  ManageModulesPaymentModuleIndexRoute: ManageModulesPaymentModuleIndexRoute,
  ManageModulesCvManagerApplicationsApplicationIdSummaryRoute:
    ManageModulesCvManagerApplicationsApplicationIdSummaryRoute,
  ManageModulesJobModuleApplicationsApplicationIdSummaryRoute:
    ManageModulesJobModuleApplicationsApplicationIdSummaryRoute,
}

const ManageRouteRouteWithChildren = ManageRouteRoute._addFileChildren(
  ManageRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  ClientRouteRoute: ClientRouteRouteWithChildren,
  ManageRouteRoute: ManageRouteRouteWithChildren,
  CRoute: CRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ProfileRoute: ProfileRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  VPublicTokenRoute: VPublicTokenRoute,
  VideoMeetingMeetingIdRoute: VideoMeetingMeetingIdRoute,
  SsoCasCompleteRoute: SsoCasCompleteRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
